<template>
  <b-card header="Passcode form">
    <b-form id="create-passcode-form">
      <b-form-group>
        <b-input-group>
          <b-input-group-prepend><b-input-group-text>Name</b-input-group-text></b-input-group-prepend>
          <b-form-input type="text" v-model="formData.name" placeholder="name"></b-form-input>
          <b-input-group-append><b-input-group-text><i class="fa fa-user"></i></b-input-group-text></b-input-group-append>
        </b-input-group>
      </b-form-group>

      <b-form-group>
        <b-input-group>
          <b-input-group-prepend><b-input-group-text>Email</b-input-group-text></b-input-group-prepend>
          <b-form-input type="text" v-model="formData.email" placeholder="email"></b-form-input>
          <b-input-group-append><b-input-group-text><i class="fa fa-at"></i></b-input-group-text></b-input-group-append>
        </b-input-group>
      </b-form-group>

      <b-form-group>
        <b-input-group>
          <b-input-group-prepend><b-input-group-text>Phone</b-input-group-text></b-input-group-prepend>
          <b-form-input type="text" v-model="formData.phone" placeholder="phone"></b-form-input>
          <b-input-group-append><b-input-group-text><i class="fa fa-phone"></i></b-input-group-text></b-input-group-append>
        </b-input-group>
      </b-form-group>

      <b-form-group>
        <b-input-group>
          <b-input-group-prepend><b-input-group-text>Start Date</b-input-group-text></b-input-group-prepend>
          <b-form-input type="date" id="startDate" format="YYYY-MM-DD HH:mm:ss" v-model="formData.startdate" placeholder="StartDate"></b-form-input>
          <b-input-group-append><b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text></b-input-group-append>
        </b-input-group>
      </b-form-group>

      <b-form-group>
        <b-input-group>
          <b-input-group-prepend><b-input-group-text>End Date</b-input-group-text></b-input-group-prepend>
          <b-form-input type="date" id="endDate" v-model="formData.enddate" placeholder="EndDate"></b-form-input>
          <b-input-group-append><b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text></b-input-group-append>
        </b-input-group>
        </b-form-group>

        <b-form-group>
          <b-input-group>
            <b-input-group-prepend><b-input-group-text>Passcode</b-input-group-text></b-input-group-prepend>
            <b-form-input type="text" v-model="formData.keyboardPwd" placeholder="passcode"></b-form-input>
            <b-input-group-append><b-input-group-text><i class="fa fa-calculator"></i></b-input-group-text></b-input-group-append>
          </b-input-group>
        </b-form-group>

        <div class="form-group form-actions">
          <b-button @click="submitData" type="submit" size="sm" variant="primary">Assign</b-button>
        </div>
    </b-form>
    <b-row>
        <b-col cols="12" md="12">
          <passcode-list></passcode-list>
        </b-col>
    </b-row>
  </b-card>

</template>

<script>
import PasscodeList from '@/views/base/haus/PasscodeList'
let qs = require('qs')
const constants = require('../shared/constants')
// import getToday from '../shared/constants'
// import getEndDate from '../shared/constants'
const BASE = constants.NEWPORT_CONST.API_URL
const API = BASE + '/api/passcodes/add'

function postdata (url, data, lockId) {
  const thisForm = document.getElementById('create-passcode-form')
  var partsStartDate = data.startdate.split('-')
  var partsEndDate = data.enddate.split('-')
  data.userName = thisForm.name.value
  data.startdate = new Date(partsStartDate[0], partsStartDate[1] - 1, partsStartDate[2]).getTime()
  data.enddate = new Date(partsEndDate[0], partsEndDate[1] - 1, partsEndDate[2]).getTime()
  data.adddate = new Date().getTime()
  data.addType = 2 // check http://open.ttlock.com.cn/doc/api/v3/keyboardPwd/add
  data.lockId = lockId

  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    },
    method: 'POST'
  })
    .then(res => res.json())
}

export default {
  name: 'passcode-edit-form',
  data () {
    return {
      formData: {
        client_id: constants.NEWPORT_CONST.CLIENT_ID,
        client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
        accessToken: localStorage.getItem('token'),
        lockId: '',
        email: '',
        name: '',
        phone: '',
        keyboardPwd: '',
        addType: '',
        adddate: '',
        enddate: '',
        startdate: ''
      }
    }
  },
  mounted () {
    //   getData(this.passcodeId).then(response => {
    //   this.$data.key = response
    //   this.$data.formData.name = this.$data.key.sharedUser.name
    //   this.$data.formData.email = this.$data.key.sharedUser.email
    //   this.$data.formData.phone = this.$data.key.sharedUser.phone
    // })
    this.$data.formData.startdate = constants.getToday()
    this.$data.formData.enddate = constants.getEndDate()
  },
  props: ['locationName', 'locationId', 'locationDescription', 'passcodeId'],
  components: {
    PasscodeList
  },
  methods: {
    submitData (evt) {
      evt.preventDefault()
      postdata(API, this.formData, this.$route.params.lockId)
        .then(data => {
          location.reload()
          console.log(data)
        })
        .catch(error => {
          console.error(error)
        })
    },
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          alert('From Submitted!')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/haus/PasscodeEditForm.vue